import { WSElement, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import {
  IPayeeEngagementResponse,
  IPayeeResponse,
  IWorkLog
} from "@wingspanhq/payments/dist/interfaces";
import { useHistory } from "react-router-dom";
import { usePayableQuery } from "../../../Invoices/screens/payables/PayableDetails";
import { DataView } from "../../../shared/components/DataView";
import { getPayeeName } from "../../Payees/selectors/getPayeeNames";
import { buildPayeeDetailsPath } from "../../Payees/utils";
import { getWorkLogPayerStatusCellProps } from "../utils/getWorkLogPayerStatusCellProps";
import styles from "./WorkLogAssignmentInfo.module.scss";

type Props = {
  shimmer?: boolean;
  workLog?: IWorkLog;
  payee?: IPayeeResponse;
  payerPayeeEngagement?: IPayeeEngagementResponse;
};

export const WorkLogAssignmentInfoPayerView: React.FC<Props> = props => {
  const history = useHistory();

  const queryPayable = usePayableQuery(props.workLog?.invoiceId!, {
    enabled: !!props.workLog?.invoiceId
  });

  const statusCellProps = props.workLog
    ? getWorkLogPayerStatusCellProps({
        workLog: props.workLog,
        payable: queryPayable.data
      })
    : undefined;

  const payeeName = props.payee ? getPayeeName(props.payee) : undefined;
  const payeeId = props.payee?.payeeId;

  return (
    <WSElement>
      <WSSectionToolbar title="Assignment information" />
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Engagement name",
            value: props.payerPayeeEngagement?.engagementName
          },
          {
            label: "Status",
            secondaryText:
              statusCellProps?.text || statusCellProps?.secondaryText,
            secondaryTextColor: statusCellProps?.secondaryTextColor,
            pill: statusCellProps?.pill,
            hideValue: true
          },
          {
            label: "Contractor name",
            value: payeeName && payeeId ? "" : payeeName,
            action:
              payeeName && payeeId
                ? {
                    label: payeeName,
                    onClick: () => history.push(buildPayeeDetailsPath(payeeId)),
                    className: styles.entityLink
                  }
                : undefined
          }
        ]}
      />
    </WSElement>
  );
};
